import React from 'react'

import {
    Box,
    CircularProgress
} from '@material-ui/core'

import styles from './loading.module.scss'

function Index(props) {

    return (
        <Box className={styles['loading-wrapper']}>
            <CircularProgress size="50px" />
        </Box>
    )
}

export default Index